var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location_on-24px",
    width: 46,
    height: 65,
    viewBox: "0 0 45.999997 64.999996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M 22.999999,0.29313458 A 22.52797,22.52797 0 0 0 0.4551905,22.83794 c 0,16.908397 22.5448085,41.868932 22.5448085,41.868932 0,0 22.54481,-24.960535 22.54481,-41.868932 A 22.52797,22.52797 0 0 0 22.999999,0.29313458 Z m 0,30.59610242 a 8.0512967,8.0512967 0 1 1 8.051297,-8.051297 8.0546647,8.0546647 0 0 1 -8.051297,8.051297 z",
    style: {
      fill: "#337ab7",
      fillOpacity: 1,
      strokeWidth: 0.84200966
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M 0,-26.799068 H 91.8 V 65.000928 H 0 Z",
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.0bc99fce6b4042d29929388ea0c9ab99.svg";
export { ForwardRef as ReactComponent };